import { render, staticRenderFns } from "./form-create-assessment-main.vue?vue&type=template&id=8a5ba916"
import script from "./form-create-assessment-main.vue?vue&type=script&lang=js"
export * from "./form-create-assessment-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports